import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from "i18next-resources-to-backend";
 
i18n
    .use(resourcesToBackend((lng, ns) => import(`./locales/${lng}/${ns}.json`))) // Динамічний імпорт
    .use(initReactI18next)      // Інтеграція з React
    .init({
        fallbackLng: 'en',      // Резервна мова
        lng: 'en',              // Мова за замовчуванням
        defaultNS: 'common',    // Нейспейс за замовчуванням
        interpolation: {
            escapeValue: false, // Без екранування для React
        },
        react: {
            useSuspense: true,  // Увімкнення режиму очікування
        },
    });

export default i18n;


/*
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// мовні модулі
import en from './locales/en.json';
import ua from './locales/ua.json';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        ua: { translation: ua },
    },
    lng: 'en', // Мова за замовчуванням
    fallbackLng: 'en', // Резервна мова
    interpolation: {
        escapeValue: false, // Не потрібне екранування для React
    },
});

export default i18n;

/** 
 * Для зміни мови використовувати 
 * const { t } = useTranslation();
 * i18n.changeLanguage('ua');
 */
